export default "__VITE_ASSET__BIHdadkz__"